import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=b0d9cb9c&scoped=true&"
import script from "./configuration.vue?vue&type=script&lang=ts&"
export * from "./configuration.vue?vue&type=script&lang=ts&"
import style0 from "./configuration.vue?vue&type=style&index=0&id=b0d9cb9c&lang=scss&scoped=true&"
import style1 from "./configuration.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d9cb9c",
  null
  
)

export default component.exports